export default {
      id: "partners-usage",
      viewBox: "0 0 100 28",
      url: __webpack_public_path__ + "sprite.svg#partners",
      toString: function () {
        return this.url;
      }
    }